import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { asArray } from './shared';
import { themeIcon } from './hooks';
import { useI18n } from './i18n';

const API = process.env.REACT_APP_API_URL || '';

// ── "Tego dnia" ──────────────────────────────────────────────────────────────
// Lacznosci z tego samego dnia w poprzednich latach. Zamienia log z tabelki
// w pamietnik -- otwierasz logger i widzisz, co robiles rok czy piec lat temu.
//
// CELOWO dyskretny: pokazuje sie TYLKO gdy jest co pokazac, da sie zwinac,
// i nie zabiera miejsca nad formularzem QSO (to on jest tu najwazniejszy).

export default function OnThisDay({ theme } = {}) {
  const { t } = useI18n();
  const [data, setData] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [expandedYear, setExpandedYear] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/qso/on-this-day`)
      .then(r => setData(r.data))
      .catch(() => {});   // ciche niepowodzenie -- to dodatek, nie rdzen
  }, []);

  const years = asArray(data?.years);
  if (years.length === 0) return null;   // nic do pokazania -- nie zabieraj miejsca

  const total = years.reduce((s, y) => s + y.count, 0);

  return (
    <div style={{ margin: '0 0 14px', padding: '10px 14px', borderRadius: 8,
      background: 'var(--bg3)', border: '1px solid var(--border)' }}>
      <button type="button" onClick={() => setCollapsed(c => !c)}
        style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%',
          background: 'none', border: 'none', cursor: 'pointer', color: 'inherit',
          padding: 0, textAlign: 'left' }}>
        <span style={{ fontSize: 15 }}>{themeIcon(theme,'🕰️','📟','🔮')}</span>
        <span style={{ fontSize: 12, color: 'var(--text-dim)', letterSpacing: '0.06em' }}>
          {t('onthisday.label')} ({data.date})
        </span>
        <span style={{ fontSize: 12, color: 'var(--accent)' }}>
          {total} {t('onthisday.qsoUnit')} {t('onthisday.inPreposition')} {years.length} {years.length === 1 ? t('onthisday.year') : t('onthisday.years')}
        </span>
        <span style={{ marginLeft: 'auto', color: 'var(--text-dim)', fontSize: 11 }}>
          {collapsed ? '▾' : '▴'}
        </span>
      </button>

      {!collapsed && (
        <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 6 }}>
          {years.map(y => (
            <div key={y.year}>
              <button type="button"
                onClick={() => setExpandedYear(e => e === y.year ? null : y.year)}
                style={{ display: 'flex', alignItems: 'baseline', gap: 10, width: '100%',
                  background: 'none', border: 'none', cursor: 'pointer', color: 'inherit',
                  padding: '4px 0', textAlign: 'left', fontSize: 13 }}>
                <strong style={{ color: 'var(--accent)', minWidth: 88 }}>
                  {y.years_ago === 1 ? t('onthisday.yearAgo') : `${y.years_ago} ${t('onthisday.yearsAgoSuffix')}`}
                </strong>
                <span style={{ color: 'var(--text-bright)' }}>{y.count} QSO</span>
                {y.country_count > 0 && (
                  <span style={{ color: 'var(--text-dim)', fontSize: 12 }}>
                    · {y.countries.slice(0, 3).join(', ')}
                    {y.country_count > 3 && ` +${y.country_count - 3}`}
                  </span>
                )}
                <span style={{ marginLeft: 'auto', color: 'var(--text-dim)', fontSize: 10 }}>
                  {expandedYear === y.year ? '▴' : '▾'}
                </span>
              </button>

              {expandedYear === y.year && (
                <div style={{ paddingLeft: 98, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {asArray(y.sample).map((s, i) => (
                    <div key={i} style={{ fontSize: 12, color: 'var(--text-dim)',
                      fontFamily: 'var(--mono)' }}>
                      {s.time} · <span style={{ color: 'var(--accent)' }}>{s.callsign}</span>
                      {' '}· {s.band} {s.mode}
                    </div>
                  ))}
                  {y.count > asArray(y.sample).length && (
                    <div style={{ fontSize: 11, color: 'var(--text-dim)', fontStyle: 'italic' }}>
                      {t('onthisday.andMorePrefix')} {y.count - asArray(y.sample).length} {t('onthisday.andMoreSuffix')}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
